import { ensureModuleMessages, registerModuleCatalog } from '@/shared/i18n/i18n';
import type { Locale } from '@/shared/i18n/locales';

// Catálogo do módulo (U33), carregado com a casca (`eager`): o título do manifesto aparece no menu, no
// ⌘K e no breadcrumb antes de a tela abrir; em produção a macro tira o texto-fonte (S31).
registerModuleCatalog('wallet', (locale: Locale) => import(`./locales/${locale}.po`), { eager: true });

export const loadWalletMessages = () => ensureModuleMessages('wallet');
